import React, {useState} from "react";
import {blogPosts} from "../portfolio";

import "./BlogPage.scss";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";

const BlogPage = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const [selectedBlog, setSelectedBlog] = useState(blogPosts[0]);

  const handleBackClick = () => {
    window.location.href = "/portfolio/public";
  };
  const changeTheme = () => {
    setIsDark(!isDark);
  };
  const renderWithInlineCode = text => {
    const parts = text.split(/(`[^`]+`)/g); // splits by backtick-wrapped words
    return parts.map((part, index) => {
      if (part.startsWith("`") && part.endsWith("`")) {
        const code = part.slice(1, -1); // remove backticks
        return (
          <code
            className={isDark ? "dark-mode inline-code" : "inline-code"}
            key={index}
          >
            {code}
          </code>
        );
      }
      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  };

  return (
    <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
      <div className={isDark ? "dark-mode blog-container" : "blog-container"}>
        <div className="blog-wrapper">
          <div className="blog-sidebar">
            {blogPosts.map((blog, index) => (
              <button
                key={index}
                className={selectedBlog.slug === blog.slug ? "active" : ""}
                onClick={() => setSelectedBlog(blog)}
              >
                {blog.title}
              </button>
            ))}
          </div>
          <div className="blog-content">
            <button className="back-button" onClick={handleBackClick}>
              ← Back to Home
            </button>
            <h1 className="blog-title">{selectedBlog.title}</h1>
            <p className="blog-date">{selectedBlog.date}</p>
            {/*<img src={selectedBlog.image} alt={selectedBlog.title} className="blog-image" />*/}
            <div className="blog-body">
              {selectedBlog.content.split("\n").map((line, index) => (
                <p key={index}>{renderWithInlineCode(line)}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </StyleProvider>
  );
};

export default BlogPage;
